webpackJsonp([213720915766396],{

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(62);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footer = __webpack_require__(121);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _TitleAndMetaTags = __webpack_require__(69);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects(_ref) {
	  var data = _ref.data;
	
	  // const projectsPage = data.wordpressPage;
	  // const folioItems = projectsPage.acf.portfolio_items;
	
	  return Glamor.createElement(
	    "div",
	    { className: "projects-page page-wrap" },
	    Glamor.createElement(_TitleAndMetaTags2.default, { title: "Aaron Ong - Full Stack Developer" }),
	    Glamor.createElement(
	      "h1",
	      { className: "page-title" },
	      "Project"
	    ),
	    Glamor.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = Projects;
	
	// // Pull the project page content from Wordpress
	// export const projectsPageQuery = graphql`
	// query projectsPageQuery {
	//   wordpressPage(slug: {eq: "projects"}) {
	//     id
	//     title
	//     content
	//     acf{
	//       portfolio_items{
	//         item_title
	//         item_image{
	//           source_url
	//         }
	//         item_url
	//       }
	//     }
	//   }
	// }
	// `
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-be6f9a5a1317f48753c4.js